import SparkLine from "../Helper/SparkLine";
import "./MarketCard.css";
import { FiStar } from "react-icons/fi"; // outline
import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// const MarketCard = ({
//   image,
//   type = "gainer",
//   data = [],
//   title = "Top Gainers",
//    isInWatchlist,
//   handleAdd,
// }) => {
//   return (
//     <div className={`market-image-card ${type}`}>
//       <div className="market-image-head">
//         <img src={image} alt={title} />
//       </div>

//       <div className="market-image-body">
//         {data?.slice(0, 5)?.map((stock, index) => {
//           const change = stock?.pChange ?? 0;
//  const isSaved = isInWatchlist?.(stock?.symbol);
//           return (
//             <div className="market-image-row" key={stock?.symbol}>
//               <div className="market-image-left">
//                 <span className="market-image-rank">
//                   {String(index + 1).padStart(2, "0")}
//                 </span>

//                 <div>
//                   <h4>{stock?.symbol}</h4>

//                   <p className="price">₹{stock?.lastPrice}</p>
//                 </div>
//               </div>
//               <div
//                 className="market-image-right"
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                 }}
//               >
//                 {type !== "active" && <SparkLine type={type} />}

//                 {type === "active" && (
//                   <p className="label">
//                     Vol: {formatVolume(stock?.totalTradedVolume)}
//                   </p>
//                 )}
//                 <button className="market-image-change">
//                   {change > 0 ? "+" : ""}
//                   {Number(change).toFixed(2)}%
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <button className="market-image-footer">View All {title} →</button>
//     </div>
//   );
// };
const MarketCard = ({
  image,
  type = "gainer",
  data = [],
  title = "Top Gainers",
  isIndia,
  isInWatchlist,
  handleAdd,
  formatVolume,
  selectedIndex,
}) => {
  const navigate = useNavigate();

  return (
    <div className={`market-image-card ${type}`}>
      <div className="market-image-head">
        <img src={image} alt={title} />
      </div>

      <div className="market-image-body">
        {data?.slice(0, 5)?.map((stock, index) => {
          const change = stock?.pChange ?? 0;
          // const parseVolume = (value) => {
          //   if (value === null || value === undefined || value === "") {
          //     return null;
          //   }

          //   // Handles:
          //   // 23837859
          //   // "23837859"
          //   // "23,837,859"
          //   const cleanedValue = String(value).replace(/,/g, "").trim();
          //   const numberValue = Number(cleanedValue);

          //   return Number.isFinite(numberValue) ? numberValue : null;
          // };

          // const currentVolume =
          //   stock?.totalTradedVolume ??
          //   stock?.quote?.totalTradedVolume ??
          //   stock?.quote?.volume ??
          //   stock?.quote?.volumeTradedToday;

          // const prevVolume = stock?.prev_volume;

          // const volumeChange =
          //   currentVolume !== null && prevVolume !== null && prevVolume > 0
          //     ? ((currentVolume - prevVolume) / prevVolume) * 100
          //     : null;

          // const volumeChangeColor =
          //   volumeChange === null
          //     ? "#6b7280"
          //     : volumeChange > 0
          //       ? "#16a34a"
          //       : volumeChange < 0
          //         ? "#dc2626"
          //         : "#6b7280";
          const isSaved = isInWatchlist?.(stock?.symbol);

          // const volumeChange=
          return (
            <div className="market-image-row" key={stock?.symbol}>
              <div className="market-image-left">
                <span className="market-image-rank">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <div>
                  <div className="market-image-symbol-row">
                    <h4
                      onClick={() =>
                        isIndia
                          ? navigate(
                              `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                            )
                          : navigate(`/globalInfo/${stock?.symbol}`)
                      }
                    >
                      {stock?.symbol}
                    </h4>

                    {isIndia && (
                      <span
                        className={`watchlist-icon ${
                          isSaved ? "active" : "inactive"
                        }`}
                        onClick={() => handleAdd?.(stock?.symbol)}
                      >
                        {isSaved ? (
                          <FaStar className="star" />
                        ) : (
                          <FiStar className="star" />
                        )}
                      </span>
                    )}
                    {/* {type === "active" && (
                      <p className="price">
                        {isIndia
                          ? `₹${stock?.lastPrice}`
                          : `${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                      </p>
                    )} */}
                    {/* {type === "active" && (
                      <>
                        <p className="price active-mobile-price">
                          {isIndia
                            ? `₹${stock?.lastPrice}`
                            : `${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                        </p>

                        <div className="active-volume-line">
                          <span className="active-volume-label">Vol:</span>

                          <span className="active-volume-value">
                            {formatVolume?.(stock?.totalTradedVolume) ?? "—"}
                          </span>

                          <span
                            className="active-volume-change"
                            style={{
                              color:
                                stock?.volumeChange > 0
                                  ? "#16a34a"
                                  : stock?.volumeChange < 0
                                    ? "#dc2626"
                                    : "#6b7280",
                            }}
                          >
                            {stock?.volumeChange === null ||
                            stock?.volumeChange === undefined
                              ? ""
                              : `(${stock.volumeChange > 0 ? "+" : ""}${Number(
                                  stock.volumeChange,
                                ).toFixed(2)}%)`}
                          </span>
                        </div>
                      </>
                    )} */}
                  </div>
                  <div className="market-image-info">
                    {type !== "active" && (
                      <p className="price">
                        {isIndia
                          ? `₹${stock?.lastPrice}`
                          : `${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                      </p>
                    )}

                    {type === "active" && (
                      <>
                        <p className="price active-mobile-price">
                          {isIndia
                            ? `₹${stock?.lastPrice}`
                            : `${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                        </p>

                        {/* <div className="active-volume-info">
                          <span className="volume-price">
                            Vol: {formatVolume?.(stock?.totalTradedVolume)}
                          </span>
                          {isIndia && (
                            <span
                              className="volume-change"
                              style={{
                                color: volumeChangeColor,
                                fontWeight: "700",
                              }}
                            >
                              {volumeChange === null
                                ? "—"
                                : `(${volumeChange > 0 ? "+" : ""}${volumeChange.toFixed(2)}%)`}
                            </span>
                          )}
                        </div> */}
                        <div className="active-volume-info">
                          <span className="volume-price">
                            Vol: {formatVolume?.(stock?.totalTradedVolume)}
                          </span>
                          {isIndia &&
                            stock?.volumeBuildPercent !== null &&
                            stock?.volumeBuildPercent !== undefined && (
                              <span
                                className="volume-change"
                                style={{
                                  color: stock.volumeBuildColor,
                                  fontWeight: "700",
                                }}
                              >
                                ({stock.volumeBuildPercent > 0 ? "+" : ""}
                                {stock.volumeBuildPercent.toFixed(2)}%)
                              </span>
                            )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="market-image-right">
                {type !== "active" && <SparkLine type={type} />}

                <button className="market-image-change">
                  {change > 0 ? "+" : ""}
                  {Number(change).toFixed(2)}%
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="market-image-footer"
        onClick={() =>
          isIndia
            ? navigate(`/stocktestdetail/${selectedIndex}/${title}`)
            : navigate(`/globaltestdetail/${title}`)
        }
      >
        View All {title} →
      </button>
    </div>
  );
};
export default MarketCard;
